import React from 'react';
import PropTypes from 'prop-types';
import GiftCardContainer from '../GiftCardDisplay/GiftCardContainer';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const SuggestionList = (props) => {
	const { addItemToCart, cardsByCategory, generateSubtotal, siteId, subtotal, userBalance } = props;

	return (
		<Stack
			alignItems='center'
			sx={{ background: (theme) => theme.palette.common.white }}
			className='filter'
			py={10}
		>
			<Typography variant='h5'>You may also like</Typography>
			<Stack sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
				{cardsByCategory?.map((card, index) => {
					return (
						<Grid xl={6} key={index}>
							<GiftCardContainer
								giftCard={card}
								addItemToCart={addItemToCart}
								generateSubtotal={generateSubtotal}
								siteId={siteId}
								subtotal={subtotal}
								userBalance={userBalance}
							/>
						</Grid>
					);
				})}
			</Stack>
		</Stack>
	);
};

SuggestionList.propTypes = {
	addItemToCart: PropTypes.func,
	cardsByCategory: PropTypes.array,
	generateSubtotal: PropTypes.func,
	siteId: PropTypes.number,
	subtotal: PropTypes.number,
	userBalance: PropTypes.object
};

export default SuggestionList;
